import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import Modal from "UI/Modal";
import Button from "UI/Button";

export default class DuplicateStoryModal extends React.Component
{
    state = {
        busy: false,
        failed: false,
        complete: false,
        redirect: false,
        storyId: null
    };

    static propTypes = {
        onConfirm: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
    };

    onDuplicate = (storyId) => {
        this.setState({busy: true});
        this.props.onConfirm(storyId).then(response => {
            console.log(response)
            this.setState({
                busy: false,
                complete: true,
                storyId: response.id
            });
        });
    };

    render()
    {
        const {open} = this.props;
        const {complete, failed, busy, redirect, storyId} = this.state;

        if (redirect) {
            return <Redirect to={`/stories/${storyId}/edit`} />;
        }

        return <Modal open={open} onClose={this.props.onClose} className="w-full max-w-sm">
            <Modal.Header>
                Duplicate Story
            </Modal.Header>
            <Modal.Content className='space-y-6'>
                {
                    complete
                        ? <p>The Story has been duplicated.</p>
                        : <p>Are you sure you wish to duplicate this Story?</p>
                }
            </Modal.Content>
            <Modal.Footer>
                {
                    complete
                        ? <>
                            <Button type="primary" onClick={() => this.setState({redirect: true})}>Edit</Button>
                            <Button onClick={this.props.onClose}>Close</Button>
                        </>
                        : <>
                            <Button type="primary" busy={busy} onClick={() => this.onDuplicate()}>Duplicate</Button>
                            <Button onClick={this.props.onClose}>Cancel</Button>
                        </>
                }
            </Modal.Footer>
        </Modal>;
    }
}
